import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  provider: PropTypes.string,
  email: PropTypes.string
}

const defaultProps = {
  provider: null,
  email: null
}

class SocialProvider extends React.Component {

  render(){
    const {provider, email} = this.props;
    if (!provider || typeof(provider) === Object) {
      return null;
    }
    return (
      <div>
        <a className={provider}>{provider}</a>{email && <span>{email}</span>}
      </div>
    );
  }

}

SocialProvider.propTypes = propTypes;
SocialProvider.defaultProps = defaultProps;

export default SocialProvider;
